<template>
  <div class="pa-0">
   
        <k-data-table style=""
          :items="filtered_tags"
          hide-actions
          :headers="headers">
          <template slot="items" slot-scope="props">
            <tr>
            <td v-on:click="tag_selected(props.item)" style="cursor: pointer;">{{get_stream_time(props.item)}}</td>
            <td v-on:click="tag_selected(props.item)" style="cursor: pointer;">{{get_title(props.item)}}</td>
            <td v-on:click="tag_selected(props.item)" style="cursor: pointer;">{{get_time(props.item)}}</td>
            <td class="text-xs-right">
              <tag-list-actions :event_uuid="event_uuid" :uuid="props.item.uuid"></tag-list-actions>
            </td>
            </tr>
          </template>
        </k-data-table>
  </div>
</template>

<script>
import Vue from 'vue'


import TagEditor from '@/components/events/tags/Editor.vue'
import TagListActions from '@/components/events/tags/ListActions.vue'
import TagModel from '@/models/tag.js'

export default {
	props: ["event_uuid"],
  components: {
    TagEditor,
    TagListActions
  },
  data () {
    var tags_ch = this.$cloudserver.channel("events:tags:"+this.event_uuid);

    return {
      ws_channel: tags_ch,
      tags: {},
      filtered_tags: [],
      headers: [
        {text: "Stream time", sortable: false, width: 20},
        {text: "Title", sortable: false},
        {text: "Time", sortable: false},
        {text: "Actions", sortable: false, align: "right", width: 300}
      ],
      tag_dialog: false
    }
  },
  created() {
    this.ws_channel.join();
    this.format_tags(this.ws_channel.data);
  },
  methods: {
    tag_selected(tag) {
      this.$emit("selected", tag);
    },
    get_title(tag) {
      return TagModel.title(tag);
    },
    get_stream_time (tag) {
      return TagModel.formatted_stream_time(tag);
    },
    get_time(tag) {
      return TagModel.formatted_date(tag) + " " + TagModel.formatted_time(tag);
    },
    format_tags(value) {
      var self = this;
      if (typeof(value.tags) != "undefined") {
        _.each(value.tags, (tag) => {
          Vue.set(self.tags, tag.uuid, tag);            
        });
      }
      if (typeof(value.tag) != "undefined") {
        var tag = value.tag;
        Vue.set(self.tags, tag.uuid, tag);
      }
      self.filtered_tags = Object.values(self.tags);
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        this.format_tags(newVal);
      },
      deep: true
    }
  }
}
</script>
